import { useQuery } from '@tanstack/react-query';
import type { HealthDetails, HealthHistory } from '@property-reports/api-contract';

export function useSystemHealth() {
  return useQuery<HealthDetails>({
    queryKey: ['admin', 'health', 'details'],
    queryFn: async () => {
      const response = await fetch('/api/health/details');
      if (!response.ok) throw new Error('Failed to fetch health details');
      return response.json();
    },
    refetchInterval: 30000,
  });
}

export function useHealthHistory(limit = 20) {
  return useQuery<HealthHistory>({
    queryKey: ['admin', 'health', 'history', limit],
    queryFn: async () => {
      const response = await fetch(`/api/health/history?limit=${limit}`);
      if (!response.ok) throw new Error('Failed to fetch health history');
      return response.json();
    },
    refetchInterval: 30000,
  });
}
